export default {
  Account: 'Account',
  Password: 'Password',
  Or: 'Or',
  Next: 'Next',
  Re_send: 'Re-send',
  Email: 'Email',

  login_dialog: {
    google_login: 'Continue with Google',
    apple_login: 'Continue with Apple',
    email_login: 'Continue with Email',
    account_login: 'Continue with Account',
    code_has_send: 'Code has been sent to {account}'
  }
}
